const offerTypes = [
	{
		id: 1,
		type: "Cash Voucher",
	},
	{
		id: 2,
		type: "Knockout Deal",
	},
	{
		id: 3,
		type: "Gift Hamper",
	},
	{
		id: 4,
		type: "Limited Deal",
	},
	{
		id: 5,
		type: "Special Offer",
	},
];

export default offerTypes;
